import { Component, input } from "@angular/core";
import { CommonModule, NgClass } from "@angular/common";
import { AreaConverterPipe } from "src/app/shared/pipes/areaconverter";

@Component({
    selector: "info-table",
    templateUrl: "./info-table.component.html",
    styleUrls: ["info-table.component.scss"],
    imports: [CommonModule, NgClass, AreaConverterPipe]
})

export class InfoTableComponent  {
    left = input.required<TableRow[]>();
    right = input.required<TableRow[]>();
    expanded = input<boolean>(true);
    defaultBackgoundColor = input<boolean>(true);

    isNumber(val: any): boolean {
        if (typeof val === 'number') {
            return true;
        } else {
            return false;
        }
    }
}

export interface TableRow {
    name: string,
    value: string | number;
}